/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';
import { PassThrough } from 'stream';

export interface PopupMenuItem {
  icon?: string;
  text?: string;
  link?: string;
  action?: () => void;
}

/** PopupMenuProps - Properties */
export interface PopupMenuItemsProps {
  id: string;
  anchor: React.RefObject<HTMLElement>;
  isOpen?: boolean;
  modal?: boolean;
  itemClick: (item: PopupMenuItem) => void;
  onClose: () => void;

  transformOrigin?: Mui.PopoverOrigin;
  anchorOrigin?: Mui.PopoverOrigin;

  color?: Mui.Colors | 'textSecondary' | 'error';
  variant?: Mui.Style | 'caption' | 'button';

  iconStyle?: any;
  textStyle?: any;

  items: PopupMenuItem[];
}

function menuEnter(target: any) {
  if (target && target.classList && target.classList.add) {
    target.classList.add('hover');
  }
}
function menuExit(target: any) {
  if (target && target.classList && target.classList.add) {
    target.classList.remove('hover');
  }
}

/** PopupMenuItems */
export class PopupMenuItems extends React.Component<PopupMenuItemsProps> {
  constructor(props: PopupMenuItemsProps, ctx: any) {
    super(props, ctx);
  }

  handleClose() {
    (this.props.onClose || (() => { }))();
  }

  private getAnchor() {
    const elem = this.props.anchor.current;
    return elem ? elem : undefined;
  }

  private onClickedItem(item: PopupMenuItem, event: React.SyntheticEvent<any>) {
    event.preventDefault();
    try {
      this.props.itemClick(item);
    }
    catch (ex) {
      console.error(ex);
      alert(ex.message);
    }
    finally {
      this.handleClose();
    }
  }

  passThroughProps(): any {
    const copy = { ...this.props };
    delete copy.isOpen;
    delete copy.onClose;
    delete copy.items;
    return copy;
  }

  render() {
    return (
      <Mui.Menu
        id={this.props.id}
        anchorEl={this.getAnchor()}
        anchorReference="anchorEl"
        anchorOrigin={this.props.anchorOrigin}
        transformOrigin={this.props.transformOrigin || { vertical: 'top', horizontal: 'left' }}
        open={!!this.props.isOpen}
        onClose={e => this.handleClose()}
      >
        {this.props.items.map((item, ix) => {
          return (
            <Mui.MenuItem key={ix} onClick={e => this.onClickedItem(item, e)} className="popupMenuItem" onMouseEnter={menuEnter} onMouseLeave={menuExit}>
              {item.icon && (<Mui.Typography
                noWrap
                color={this.props.color || 'default'}
                variant={this.props.variant || 'subheading'}
              >
                <Mui.Icon style={this.props.iconStyle || { marginTop: '4px', marginRight: '16px', marginLeft: '16px' }}>{item.icon}</Mui.Icon>
              </Mui.Typography>
              )}
              {item.text && (<Mui.Typography
                noWrap
                style={this.props.textStyle || { marginRight: '16px' }}
                color={this.props.color || 'default'}
                variant={this.props.variant || 'subheading'}
              >
                {item.text}
              </Mui.Typography>
              )}
            </Mui.MenuItem>
          );
        })}
      </Mui.Menu>
    );
  }
}

export default PopupMenuItems;


// WEBPACK FOOTER //
// ./src/components/popupMenuItems.tsx